import { Material, MaterialCreator, MaterialOption } from '@root/globalTypes';
import { compareAsc } from 'date-fns';

export const getLastCreator = (firstCreator?: MaterialCreator, secondCreator?: MaterialCreator) => {
  const firstCreatedAt = firstCreator?.createdAt ? new Date(firstCreator.createdAt) : undefined;
  const secondCreatedAt = secondCreator?.createdAt ? new Date(secondCreator.createdAt) : undefined;

  if (firstCreatedAt && secondCreatedAt) {
    if (compareAsc(firstCreatedAt, secondCreatedAt)) return firstCreator;
    return secondCreator;
  }

  if (!secondCreatedAt && firstCreatedAt) return firstCreator;
  if (!firstCreatedAt && secondCreatedAt) return secondCreator;
  return undefined;
};

export const setFinalAndEstimatedValuesForFinalYard = (
  { includeEstimated, finalQuantity, estimatedQuantity, valueType }: MaterialOption,
  withFinal: boolean,
) => {
  const setValue = (value?: string) => (valueType === 'number' ? parseFloat(value || '') : value);

  if (includeEstimated) {
    if (!withFinal) return { estimatedQuantity: setValue(estimatedQuantity) };
    return {
      finalQuantity: setValue(finalQuantity),
      estimatedQuantity: setValue(estimatedQuantity),
    };
  }
  return {
    estimatedQuantity: setValue(finalQuantity),
    finalQuantity: setValue(finalQuantity),
  };
};

export const sortMaterials = (data?: Material[]) => {
  if (!data) return [];
  return data.sort((a, b) => {
    if (!a.productFullName || !b.productFullName) return 0;
    return a.productFullName?.localeCompare(b.productFullName || '', undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });
};
